import DefaultMapper from '../../dataProvider/DefaultMapper';
import {API_BASE_PATH_ADMIN} from "../../constants";

class MT940FileMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'payment/mt940/files';
	}

	prepareUpdate({ params, options }) {
		options.url = `${API_BASE_PATH_ADMIN}/payment/mt940/files/${params.data.id}:changeStatus`;
		options.method = 'POST';
		const data = {
			comment: params.data.comment,
			status: params.data.status
		};
		options.body = JSON.stringify(data);
	}

	prepareCreate({ params, options, mappedResource }) {
		const { businessContractId } = params.data;
		options.url = `${API_BASE_PATH_ADMIN}/payment/mt940/files`;
		options.method = 'POST';
		const formDataRequest = new FormData();
		formDataRequest.append('file', params.data.file.rawFile);
		formDataRequest.append('request', new Blob([
			JSON.stringify({ businessContractId })
		], {
			type: "application/json"
		}));
		options.body = formDataRequest;
	}
}

export default MT940FileMapper;
